export const DILUENT_FACTOR_MAX = 100;
export const DILUENT_FACTOR_MIN = 1;
export const VOLUME_MIN = 0.01;
export const CONCENTRATION_LIMIT_COMMA = 6;
